import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFullPageError = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 1379 992",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#full-page-error_svg__a)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#full-page-error_svg__b)",
				d: "m1231 0-63.72 324.321-557.925 442.343L100 785s73.946-118.121 189.61-152.684c115.663-34.562 302.118-87.939 332.149-203.93C650.006 319.324 589.356 98.391 817.723 0z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#CED0E0",
				d: "M1381 0v995H0c16.284-64.2 93.787-311.248 331.301-353.876 273.435-49.055 373.121-119.146 383.331-294.353C724.865 171.565 823.68 90.569 980.426 90.569c91.584 0 111.054-49.454 111.374-90.569z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#full-page-error_svg__c)",
				d: "M1381 200v795H605c32.538-95.062 119.227-273.939 317.918-309.615 273.362-49.074 373.022-119.191 383.232-294.464 5.01-85.626 31.12-148.735 74.85-190.921",
				opacity: .2,
				style: { mixBlendMode: "screen" }
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#848BB2",
				d: "M527.995 570.687c94.438 0 170.996-10.888 170.996-24.319s-76.558-24.319-170.996-24.319S357 532.937 357 546.368s76.557 24.319 170.995 24.319",
				opacity: .2
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#full-page-error_svg__d)",
				d: "M651.865 533.484c-13.335-10.526-62.955-18.376-122.101-18.376s-113.346 8.576-123.733 19.828l-1.95-1.497v5.671c0 13.294 56.287 24.047 125.683 24.047s125.684-10.753 125.684-24.047v-5.671h-3.538z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#full-page-error_svg__e)",
				d: "M655.404 533.481c0 13.294-56.288 24.047-125.684 24.047s-125.684-10.753-125.684-24.047c0-13.293 56.288-24.046 125.684-24.046s125.684 10.753 125.684 24.046"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#full-page-error_svg__f)",
				d: "M614.989 532.659c-21.499 5.036-51.752 8.167-85.271 8.167-29.708 0-56.832-2.45-77.56-6.533-2.676-.545-5.216-1.044-7.665-1.634-1.814-.453-2.812-2.359-2.177-4.129l12.11-33.211.544-1.498.907-2.45 13.925-38.202.499-1.316 14.559-39.836 2.586-7.033 13.335-36.479.998-2.722 19.185-52.449c2.676-7.441 15.014-7.441 17.69 0l17.326 47.458 1.814 4.991.998 2.722 13.335 36.479 2.585 7.033 14.56 39.836.499 1.316 13.924 38.202.907 2.45.545 1.498 12.11 33.211c.68 1.77-.363 3.676-2.177 4.129z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#F9FBFC",
				d: "M603.605 491.422c-20.23 3.131-45.947 4.991-73.887 4.991s-53.657-1.86-73.886-4.991l13.924-38.202c17.554 1.996 38.055 3.13 59.962 3.13s42.364-1.134 59.962-3.13zM572.037 405.033c-13.153.953-27.441 1.497-42.318 1.497s-29.21-.544-42.318-1.497l13.335-36.479.998-2.722a619 619 0 0 0 56.061 0l.998 2.722 13.335 36.479z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#E9E5D9",
				d: "M614.99 532.663c-21.499 5.036-51.753 8.167-85.271 8.167-29.709 0-56.832-2.45-77.56-6.534 19.367-.544 54.428-4.401 82.458-23.321 34.971-23.593 24.992-121.686 21.318-150.179l1.814 4.991.998 2.722 13.335 36.479 2.585 7.032 14.56 39.836.499 1.316 13.925 38.203.907 2.45.544 1.497 12.11 33.212c.681 1.77-.363 3.675-2.177 4.129z",
				style: { mixBlendMode: "multiply" }
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#B9BDD2",
				d: "M1020.24 732.597c3.08-.05 43.11-7.688 43.11-7.688l73.51-62.666-81.68-18.446zM782.424 755.391l45.932-6.077 144.538-114.248c5.542-4.382 3.89-13.188-2.863-15.258l-66.814-20.533z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#182676",
				d: "M972.769 392.505v-.376c0-.083 0-.158-.017-.242v-.058c0-.092-.016-.192-.025-.284a4 4 0 0 0-.041-.284v-.083c-.009-.067-.025-.134-.034-.201-.017-.091-.042-.183-.058-.275-.009-.042-.025-.083-.034-.125q-.002-.024-.016-.059c0-.033-.017-.058-.025-.091a2 2 0 0 0-.084-.268 3 3 0 0 0-.092-.25v-.008c-.033-.092-.066-.176-.1-.267a3 3 0 0 0-.117-.259c-.008-.025-.025-.042-.033-.067 0-.017-.017-.033-.025-.05-.025-.05-.042-.092-.067-.142-.042-.083-.083-.167-.125-.242-.033-.058-.067-.125-.1-.184 0-.008-.009-.016-.017-.025q-.002-.012-.017-.025c-.041-.075-.091-.15-.133-.225s-.092-.142-.142-.217c-.017-.033-.042-.058-.058-.092-.009-.016-.017-.025-.025-.042l-.059-.083c-.05-.075-.108-.15-.159-.217l-.166-.217s-.009-.017-.017-.017c-.009-.008-.017-.025-.025-.033-.059-.075-.125-.15-.184-.225-.058-.067-.125-.134-.183-.201-.042-.042-.084-.092-.126-.133-.016-.017-.041-.042-.058-.067a4 4 0 0 0-.326-.309c-.033-.033-.066-.067-.108-.1l-.017-.017c-.142-.125-.284-.25-.434-.375-.025-.017-.042-.034-.067-.05a.2.2 0 0 0-.058-.042c-.05-.042-.1-.084-.159-.125-.091-.067-.175-.134-.267-.192-.033-.025-.066-.05-.108-.067-.017-.008-.034-.025-.05-.034-.034-.025-.067-.041-.1-.066-.092-.059-.176-.117-.268-.167-.066-.042-.141-.084-.208-.125-.017 0-.025-.017-.042-.025-.008 0-.025-.017-.033-.017a5 5 0 0 0-.292-.159c-.101-.05-.209-.108-.309-.158s-.201-.092-.309-.142a6 6 0 0 0-.326-.134c-.016 0-.025-.008-.041-.016-.017 0-.034-.009-.05-.017-.084-.034-.159-.059-.242-.092a5 5 0 0 0-.326-.108l-.092-.026c-.008 0-.017 0-.033-.008h-.009c-.066-.017-.133-.042-.192-.058a4 4 0 0 0-.333-.084c-.025 0-7.846-1.786-7.871-1.786l-8.906 6.919s8.263 1.528 8.372 1.553c.108.033.217.058.325.092s.217.066.326.108c.108.042.217.075.325.117.042.017.092.033.134.059q.26.099.509.225.25.123.501.259c.016.008.041.025.058.033.159.083.309.175.459.267.025.017.042.025.067.042.142.092.284.192.426.292l.075.05c.142.1.275.2.4.309.067.058.134.117.201.167.083.067.158.133.242.208.092.084.175.167.258.251.059.058.117.108.167.167.05.05.092.1.142.15.084.092.167.175.242.275q.035.038.059.076c.108.125.208.258.309.392 0 .008.016.025.025.033l.3.426a.2.2 0 0 0 .025.042c.092.142.175.283.259.425.008.017.025.034.033.059.084.142.151.292.226.434.008.025.025.042.033.067.067.141.134.292.192.442.008.025.017.042.025.067q.085.225.159.45c0 .025.016.042.016.067.05.15.092.309.125.468 0 .016.009.041.017.058q.053.238.092.476c.008.083.025.158.033.242l.025.284c0 .1.017.2.017.3v.301c0 .108 0 .217-.017.333 0 .084-.016.176-.025.259 0 0-.016.167-.05.468l-2.629 24.572c-.492-.108-6.168 7.52-6.001 7.604.017.008-14.073 183.317-14.073 183.317-.091.835-3.372 6.811-2.57 6.201l8.38-8.43c1.778-1.786 2.871-3.931 3.096-6.051l22.353-212.213.225-2.078.025-.259c0-.075 0-.142.008-.217v-.042z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#273897",
				d: "m963.822 383.782-322.055-73.183h-.025l-.476-.109c-.367-.083-.801-.183-.851-.192a4 4 0 0 0-.334-.058l-.334-.05c-.109-.017-.225-.025-.334-.034l-.342-.025c-.117 0-.234-.008-.342-.008h-.426c-.109 0-.209.008-.317.017-.05 0-.109.008-.159.016-.042 0-.083.009-.133.017-.034 0-.067 0-.101.008-.125.017-.25.034-.375.059h-.034q-.227.04-.442.092c-.017 0-.033.008-.05.016-.067.017-.134.034-.2.059-.075.025-.159.042-.234.067-.025 0-.042.016-.067.025-.108.033-.208.075-.317.116-.058.026-.117.042-.167.059a.06.06 0 0 0-.033.017 7 7 0 0 0-.601.283c-.017 0-.025.017-.042.017a.14.14 0 0 0-.058.042 6 6 0 0 0-.718.467l-8.731 6.602a8 8 0 0 1 .701-.459q.14-.075.293-.15c.116-.058.233-.117.35-.167l.434-.175c.059-.017.109-.042.167-.059.209-.066.417-.125.634-.175l.126-.025c.217-.05.442-.092.667-.117h.05c.242-.025.484-.05.735-.058h.058c.242 0 .493 0 .743.017h.075c.267.016.526.05.802.091.108.017.217.034.325.059.084.017.167.033.259.058l1.786.409 322.556 73.3 7.545-6.869z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0A1450",
				d: "m956.852 390.501-324.943-73.834c-4.407-1.001-8.321 1.352-8.739 5.267L604.19 499.4c-.025.2-.025.392-.025.593l-4.424 40.289c-.417 3.914 3.331 7.787 7.746 8.789l324.934 73.834c4.407 1.002 8.322-1.352 8.739-5.267l20.8-198.04q.036-.351.034-.701l2.086-19.49c.418-3.914-2.813-7.896-7.228-8.897z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#08124A",
				d: "m937.154 624.79-11.544 8.714-3.079-4.59-322.715-78.066c-3.889-.943-11.301 1.085-15.441 4.256l-129.231 98.407-.15-1.836-19.748 13.413-2.955-.3 1.035 7.954c.451 1.677 1.878-.334 3.189-.017l335.284 84.201c3.889.943 10.483-.676 14.631-3.848l145.332-111.052c2.262-1.728 3.956-4.757 3.856-6.176l1.527-11.068z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#24317D",
				d: "M599.825 550.848c-3.89-.943-11.301 1.085-15.441 4.256l-129.231 98.407-.151-1.836-19.748 13.413-3.071-2.771.451 9.74c0 1.611 1.302 2.212 2.62 2.529l336.561 82.348c1.603.384 3.656.343 5.81-.066l-8.197-81.196c2.262-1.728-169.603-124.833-169.603-124.833z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0A1866",
				d: "M770.789 746.268 434.97 665.031c-3.889-.944-3.672-4.307.476-7.479l151.433-113.589c4.148-3.172 11.285-4.349 15.174-3.406l332.522 80.445c3.889.943 3.672 4.307-.476 7.479L785.395 742.22c-4.148 3.172-10.717 5-14.606 4.057z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#3F4C94",
				d: "M622.361 572.766c-.476.342-1.444.484-2.162.317l-19.974-4.716c-.717-.167-.918-.584-.45-.934l13.079-9.499c.476-.342 1.444-.484 2.162-.317l19.973 4.716c.718.167.927.584.451.926l-13.079 9.499zM645.74 595.619c-.476.35-1.436.492-2.171.317l-19.973-4.716c-.718-.167-.918-.584-.442-.935l13.079-9.498c.467-.334 1.427-.484 2.145-.309l19.973 4.716c.726.175.927.593.459.926l-13.079 9.499zM634.238 610.242c-.476.342-1.435.484-2.153.309l-19.974-4.716c-.709-.167-.926-.585-.45-.927l13.087-9.507c.459-.333 1.444-.475 2.153-.308l19.974 4.715c.718.167.918.585.459.927l-13.088 9.507zM602.754 620.141c-.467.343-1.435.485-2.153.318l-19.974-4.716c-.709-.167-.909-.584-.45-.927l13.079-9.498c.467-.342 1.444-.484 2.162-.317l19.973 4.715c.718.167.91.593.443.927zM548.026 626.751c-.476.342-1.444.484-2.162.309l-19.974-4.716c-.717-.167-.926-.584-.45-.926l15.357-11.152c.46-.333 1.436-.484 2.162-.308l19.974 4.715c.718.167.909.593.45.927zM582.464 634.873c-.476.343-1.619.443-2.571.217l-26.167-6.176c-.934-.217-1.327-.684-.851-1.027l15.358-11.151c.459-.334 1.627-.434 2.562-.217l26.167 6.177c.951.225 1.319.693.86 1.026zM754.379 675.562c-.392.284-1.293.376-2.02.209l-19.956-4.707c-.727-.176-1.002-.543-.61-.827l5.676-4.123c.392-.284 1.302-.375 2.028-.209l19.957 4.708c.718.167.985.542.593.826l-5.676 4.123zM781.064 682.198c-.393.284-1.294.376-2.02.209l-19.957-4.708c-.726-.175-1.002-.542-.609-.826l5.675-4.123c.393-.284 1.302-.376 2.029-.209l19.956 4.708c.718.167.985.542.593.826l-5.676 4.123zM809.359 688.567c-.376.276-1.278.359-1.995.192l-19.965-4.716c-.718-.166-1.01-.534-.626-.809l5.467-3.973c.375-.276 1.285-.359 2.003-.184l19.965 4.716c.718.167.993.534.626.81l-5.467 3.973zM791.839 674.545c-.375.275-1.277.359-1.995.192l-19.965-4.716c-.718-.167-1.01-.534-.626-.81l5.467-3.973c.376-.275 1.286-.359 2.003-.183l19.966 4.716c.717.166.993.534.626.809l-5.468 3.973zM719.858 667.291c-.476.343-1.452.484-2.17.309l-129.974-30.674c-.709-.167-.926-.584-.451-.926l15.358-11.151c.459-.334 1.452-.476 2.162-.309l129.974 30.674c.726.167.926.592.459.926z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#3F4C94",
				d: "M578.875 631.643s-.125.025-.209 0l-15.266-3.606c-.083-.017-.133-.05-.1-.075l.952-.693s.125-.025.208 0l15.266 3.606c.084.016.134.058.1.075zM539.712 621.009s-.083.033-.116.025l-6.486-1.527s-.041-.034-.008-.051l.951-.692s.084-.034.117-.025l6.486 1.527s.041.033.008.05zM630.14 626.593c-.467.342-1.436.484-2.162.309l-19.973-4.716c-.71-.167-.918-.592-.451-.926l13.079-9.499c.468-.342 1.461-.484 2.162-.317l19.973 4.716c.727.167.919.592.451.935zM657.634 633.087c-.468.342-1.444.484-2.154.317l-19.973-4.716c-.718-.167-.927-.593-.459-.926l13.079-9.499c.467-.342 1.452-.484 2.17-.317l19.974 4.716c.709.167.909.592.442.926zM685.136 639.572c-.468.342-1.436.484-2.154.317l-19.973-4.716c-.71-.167-.91-.584-.443-.926l13.08-9.499c.467-.342 1.444-.484 2.153-.317l19.974 4.716c.709.167.909.593.442.927zM712.638 646.066c-.467.342-1.436.484-2.153.317l-19.974-4.715c-.726-.167-.918-.593-.451-.927l13.079-9.498c.468-.343 1.444-.484 2.162-.318l19.974 4.716c.718.167.91.593.442.927zM740.14 652.559c-.467.342-1.444.484-2.17.309l-19.965-4.716c-.71-.167-.91-.584-.443-.927l13.08-9.498c.467-.342 1.444-.484 2.153-.317l19.965 4.716c.726.167.927.592.459.935zM767.651 659.037c-.468.343-1.444.485-2.162.309l-19.965-4.716c-.718-.166-.918-.592-.451-.926l13.079-9.498c.468-.343 1.444-.485 2.162-.318l19.965 4.716c.718.167.918.593.451.935zM829.591 673.66c-.468.342-1.436.484-2.162.309l-54.412-12.845c-.717-.167-.918-.593-.45-.927l13.079-9.498c.467-.343 1.444-.484 2.162-.317l54.411 12.845c.718.167.918.593.451.935zM661.607 616.686c-.476.342-1.428.484-2.145.309l-19.974-4.716c-.718-.167-.926-.584-.451-.926l13.088-9.507c.459-.334 1.435-.476 2.153-.309l19.974 4.716c.726.167.91.584.451.926l-13.088 9.507zM689.117 623.179c-.476.342-1.444.476-2.154.309l-19.981-4.716c-.71-.167-.918-.576-.443-.926l13.088-9.507c.459-.334 1.435-.476 2.145-.309l19.982 4.716c.709.167.918.584.45.926zM716.611 629.673c-.476.343-1.444.476-2.154.309l-19.973-4.716c-.71-.167-.935-.584-.459-.926l13.087-9.507c.459-.334 1.453-.476 2.162-.309l19.974 4.716c.709.167.918.584.459.927l-13.088 9.506zM744.113 636.159c-.476.342-1.435.484-2.153.309l-19.965-4.716c-.718-.167-.927-.585-.451-.927l13.087-9.507c.459-.333 1.436-.475 2.154-.308l19.965 4.715c.718.167.918.585.451.927zM771.624 642.644c-.476.342-1.444.476-2.154.309l-19.982-4.716c-.717-.167-.918-.584-.45-.926l13.087-9.507c.459-.334 1.427-.476 2.145-.309l19.982 4.716c.71.167.918.584.451.926l-13.088 9.507zM799.117 649.129c-.476.342-1.436.484-2.153.308l-19.965-4.716c-.727-.175-.935-.584-.46-.926l13.088-9.507c.459-.334 1.436-.476 2.162-.309l19.965 4.716c.718.167.91.584.451.927zM826.619 655.623c-.475.342-1.435.484-2.153.308l-19.982-4.715c-.709-.167-.918-.576-.442-.927l13.087-9.507c.459-.334 1.428-.475 2.145-.308l19.982 4.715c.71.167.91.585.451.927zM673.116 602.071c-.475.351-1.444.484-2.161.318l-19.974-4.716c-.709-.167-.91-.585-.434-.935l13.079-9.499c.468-.334 1.436-.475 2.145-.308l19.974 4.715c.718.167.918.585.459.927l-13.079 9.498zM700.61 608.556c-.475.35-1.444.484-2.161.317l-19.974-4.716c-.718-.167-.918-.584-.442-.935l13.079-9.498c.467-.334 1.435-.476 2.153-.309l19.974 4.716c.709.167.91.584.45.926zM728.113 615.05c-.476.35-1.444.484-2.171.317l-19.973-4.716c-.709-.167-.91-.584-.434-.935l13.079-9.498c.468-.334 1.436-.476 2.145-.309l19.974 4.716c.726.167.926.593.459.926zM755.606 621.535c-.475.351-1.435.493-2.161.317l-19.974-4.715c-.718-.167-.918-.585-.442-.935l13.079-9.499c.467-.334 1.436-.476 2.153-.309l19.974 4.716c.718.167.91.585.451.927zM783.117 628.02c-.476.351-1.444.484-2.154.317l-19.973-4.715c-.726-.167-.918-.585-.443-.935l13.08-9.499c.467-.334 1.427-.484 2.153-.309l19.973 4.716c.71.167.91.585.443.927zM810.627 634.514c-.475.35-1.444.484-2.17.317l-19.973-4.716c-.71-.167-.918-.584-.443-.935l13.08-9.498c.467-.334 1.444-.476 2.145-.309l19.973 4.716c.726.175.927.592.459.926l-13.079 9.499zM838.121 641c-.476.351-1.444.484-2.162.317l-19.973-4.716c-.718-.167-.918-.584-.443-.934l13.08-9.499c.467-.334 1.435-.476 2.153-.309l19.973 4.716c.71.167.91.584.451.927zM618.238 589.125c-.476.351-1.444.484-2.171.317l-33.862-7.996c-.718-.167-.926-.584-.442-.935l13.079-9.498c.467-.334 1.436-.476 2.153-.309l33.863 7.996c.717.167.918.593.459.927zM883.635 634.405c-.476.342-1.444.484-2.162.317l-33.862-7.996c-.709-.167-.918-.584-.442-.926l13.079-9.499c.476-.342 1.452-.484 2.162-.317l33.862 7.996c.718.167.918.584.451.927l-13.079 9.498zM606.727 603.748c-.475.342-1.427.484-2.153.309l-40.373-9.532c-.718-.167-.926-.584-.45-.926l13.087-9.507c.459-.334 1.436-.476 2.154-.309l40.372 9.532c.726.175.918.584.459.926l-13.087 9.507zM575.261 613.656c-.468.342-1.444.484-2.162.309l-26.918-6.352c-.718-.167-.918-.593-.451-.927l13.08-9.498c.467-.342 1.443-.484 2.161-.317l26.918 6.352c.718.166.918.592.451.934zM649.854 579.26c-.475.342-1.435.484-2.17.317l-19.957-4.708c-.717-.167-.918-.584-.45-.935l13.079-9.498c.476-.342 1.444-.484 2.162-.317l19.956 4.707c.727.176.927.585.451.935l-13.079 9.499zM677.231 585.712c-.475.342-1.444.484-2.161.317l-19.974-4.716c-.718-.167-.918-.584-.451-.926l13.08-9.499c.475-.342 1.443-.484 2.161-.317l19.974 4.716c.718.167.926.584.45.935l-13.079 9.498zM704.725 592.197c-.476.342-1.435.484-2.153.317l-19.974-4.716c-.718-.166-.918-.584-.442-.926l13.079-9.499c.476-.342 1.444-.484 2.153-.317l19.974 4.716c.726.167.918.584.442.927zM732.236 598.691c-.476.342-1.444.484-2.162.317l-19.957-4.707c-.726-.167-.926-.584-.451-.935l13.079-9.498c.476-.343 1.444-.484 2.162-.318l19.957 4.708c.718.167.927.584.451.926l-13.079 9.499zM759.721 605.176c-.476.342-1.427.484-2.153.317l-19.965-4.716c-.727-.166-.927-.584-.451-.934l13.079-9.499c.476-.342 1.444-.484 2.162-.317l19.965 4.716c.726.167.91.584.442.926l-13.079 9.499zM787.24 611.662c-.476.342-1.444.484-2.154.317l-19.981-4.716c-.71-.167-.91-.584-.443-.926l13.079-9.499c.476-.342 1.436-.484 2.154-.317l19.982 4.716c.709.167.918.584.442.926zM814.742 618.147c-.476.342-1.444.484-2.162.317l-19.973-4.716c-.726-.167-.927-.593-.451-.935l13.079-9.498c.476-.342 1.444-.484 2.17-.309l19.974 4.716c.718.167.926.584.451.926l-13.08 9.499zM842.236 624.639c-.476.343-1.436.485-2.153.318l-19.991-4.716c-.709-.167-.909-.584-.434-.927l13.08-9.498c.475-.342 1.435-.484 2.153-.317l19.99 4.716c.71.166.91.584.434.926zM858.278 632.352a3.2 3.2 0 0 0-1.169-.033c-.417.058-.759.184-.976.351l-13.079 9.498c-.217.159-.317.351-.234.534.092.175.334.317.668.401l5.216 1.227-17.152 12.461c-.225.159-.309.351-.217.535.092.183.334.317.676.4l13.455 3.172c.342.083.751.1 1.177.042.417-.059.768-.184.993-.351l31.1-22.586c.217-.159.308-.342.217-.526-.084-.183-.334-.317-.676-.4l-19.974-4.716z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#3F4C94",
				d: "M571.647 609.19s-.126.025-.209 0l-15.266-3.605c-.083-.017-.134-.05-.1-.075l.951-.693s.126-.025.209 0l15.266 3.606c.083.016.134.05.1.075zM652.634 697.907l-73.208-16.827c-.852-.192-.843-.859.017-1.477l30.732-22.135c.86-.618 2.253-.96 3.096-.768l73.209 16.827c.851.192.843.859-.017 1.477l-30.732 22.135c-.86.618-2.254.96-3.097.768"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#CED0E0",
				d: "m947.086 406.193-306.93-66.581c-4.165-.902-7.863 1.035-8.255 4.332l-2.529 20.966a4.7 4.7 0 0 0-.175.785l-16.552 150.323c-.4 3.297 3.356 6.285 7.521 7.195l304.518 72.557c4.165.901 7.863-1.035 8.255-4.332l2.746-27.419a4.6 4.6 0 0 0 .175-.784l18.046-149.438c.4-3.297-2.655-6.694-6.82-7.596z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#3D477A",
				d: "M819.266 722.504a1.117 1.117 0 0 1-.684-2.003l13.588-10.508a1.116 1.116 0 0 1 1.569.2 1.116 1.116 0 0 1-.2 1.569l-13.589 10.509c-.2.158-.442.233-.684.233M802.289 735.885a1.117 1.117 0 0 1-.684-2.003l13.588-10.508a1.116 1.116 0 0 1 1.569.2 1.116 1.116 0 0 1-.2 1.569l-13.589 10.509c-.2.158-.442.233-.684.233"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#272B47",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2.02,
				d: "m1043.3 514.516-9.93-9.932 15.24-4.449z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#E1F3FF",
				d: "m908.141 581.746-204-48.577c-3.556-.826-5.609-5.434-5.2-9.04l15.792-134.606c.584-5.133 6.669-16.968 11.735-15.8l204.125 47.326c3.556.826 5.76 3.931 5.351 7.537l-16.66 145.365c-.585 5.133-6.077 8.972-11.143 7.804z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#7A90CC",
				d: "m934.542 440.814 2.27-16.986c.409-3.605-1.786-6.71-5.35-7.537l-204.126-47.325c-5.066-1.177-10.558 2.671-11.142 7.804l-1.494 13.046 219.842 50.99z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M732.419 382.262c-.025 1.603-1.402 2.78-3.071 2.63-1.669-.151-3.005-1.578-2.98-3.181s1.402-2.779 3.072-2.629c1.669.15 3.005 1.578 2.979 3.18M741.367 384.382c-.025 1.603-1.402 2.78-3.072 2.63-1.669-.151-3.005-1.578-2.979-3.18s1.402-2.78 3.071-2.63c1.669.151 3.005 1.578 2.98 3.18M750.114 386.602c-.025 1.603-1.402 2.78-3.071 2.629s-3.005-1.577-2.98-3.18c.025-1.602 1.402-2.779 3.071-2.629s3.005 1.578 2.98 3.18"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#7A90CC",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2.32,
				d: "M766.857 415.533 752.46 529.189"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#fff",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 3.97,
				d: "m732.912 415.191 18.997 4.399M723.889 464.971l19.006 4.398M723.38 477.273l19.005 4.399M722.838 490.403l19.005 4.399"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#4C66A6",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2.77,
				d: "m739.047 429.932 10.324 2.395M737.628 442.928l9.206 2.128M733.538 455.297l10.759 2.487"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#7A90CC",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2.32,
				d: "m730.141 503.323 10.333 2.396M728.722 516.319l9.214 2.129M776.573 425.834l129.498 29.505M796.054 510.227l96.329 22.168"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#fff",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 3.97,
				d: "m769.662 504.217 15.45 3.514"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#7A90CC",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2.32,
				d: "m842.111 538.446 47.759 10.884M847.236 460.256l54.303 11.986"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#fff",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 3.97,
				d: "m790.829 447.41 36.959 8.422"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#7A90CC",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2.32,
				d: "m790.045 466.407 109.591 24.973M840.433 500.336l55.188 11.76"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#fff",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 3.97,
				d: "m810.177 493.483 19.656 4.758M789.118 488.65l12.67 2.888"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#848BB2",
				d: "m866.182 531.802-232.428-50.205c-4.057-.852-6.394-6.043-5.926-10.158l17.987-153.553c.667-5.851 7.595-19.473 13.371-18.262l232.57 48.777c4.057.852 6.561 4.324 6.093 8.439l-18.98 165.814c-.668 5.851-6.928 10.366-12.695 9.156z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "m896.255 370.795 2.588-19.381c.467-4.115-2.037-7.587-6.093-8.439l-232.571-48.777c-5.767-1.211-12.027 3.297-12.695 9.156l-1.703 14.882z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#646AA3",
				d: "M665.972 309.189c-.026 1.828-1.595 3.196-3.498 3.063-1.903-.134-3.422-1.72-3.397-3.539.025-1.828 1.594-3.197 3.497-3.063s3.423 1.719 3.398 3.539M676.163 311.375c-.025 1.828-1.594 3.197-3.497 3.063s-3.422-1.719-3.397-3.539c.025-1.828 1.594-3.196 3.497-3.063 1.903.134 3.422 1.72 3.397 3.539M686.129 313.695c-.025 1.828-1.594 3.197-3.497 3.064-1.903-.134-3.422-1.72-3.397-3.539.025-1.828 1.594-3.197 3.497-3.064 1.903.134 3.422 1.72 3.397 3.539",
				opacity: .21,
				style: { mixBlendMode: "multiply" }
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#3C56A1",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2.64,
				d: "m705.209 346.188-17.853 141.159"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#fff",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2.51,
				d: "m666.531 346.647 21.651 4.533M656.256 403.513l21.651 4.532M655.672 417.519l21.651 4.532M655.054 432.468 676.706 437"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#3C56A1",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2.64,
				d: "m673.517 363.266 11.769 2.462M671.898 378.081l10.5 2.195M668.484 392.521l11.018 2.303M663.376 446.991l11.769 2.462M661.757 461.806l10.491 2.203M658.51 476.287l10.851 2.27"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#fff",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2.51,
				d: "m716.277 357.665 147.535 30.357M738.471 453.209l109.75 22.828M708.398 447.016l17.611 3.63"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#333",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2.85,
				d: "m790.946 484.166 54.412 11.201M796.781 395.083l61.873 12.286"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#fff",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2.51,
				d: "m732.52 381.861 42.108 8.664"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#333",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2.85,
				d: "m731.627 403.497 124.865 25.691"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#fff",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2.51,
				d: "m789.035 440.856 62.875 12.003M754.563 433.803l22.394 4.933M730.575 428.828l14.431 2.972"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#17AD86",
				d: "m916.337 434.889-60.746-13.071c-3.64-.784-6.235-4.39-5.768-8.021l7.136-55.538c.468-3.631 3.823-5.96 7.462-5.175l60.747 13.071c3.639.784 6.235 4.39 5.768 8.021l-7.137 55.538c-.467 3.631-3.823 5.96-7.462 5.175"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "m860.574 386.697.509-3.497 20.274-2.388-.593 4.04-8.747.743-6.127.534-.025.167 5.534 3.456 7.921 4.916-.593 4.04zM894.402 377.048l3.372.843L882.4 411.57l-3.372-.843zM897.107 399.125l8.747-.742 6.126-.543.026-.167-5.534-3.455-7.921-4.917.592-4.039 18.154 12.011-.509 3.497-20.274 2.387.593-4.04z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0A1866",
				d: "m1091.67 489.033-92.71-20.591c-1.886-.259-7.987.643-12.227 4.148l-55.347 42.551 56.732 39.33 3.356 147.242c-.084 3.314 11.306 4.808 14.036 5.409 0 0 8.83-4.09 20.78-9.724l2.29 32.435 54.33-47.918c4.23-3.731 6.85-8.68 6.95-13.171l.1-3.981 6.51-168.644c.08-3.313-2.07-6.485-4.8-7.094z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#2D3E9F",
				d: "m1091.67 489.033-92.71-20.591c-1.886-.259-7.987.643-12.227 4.148l-55.347 42.551 103.674 24.806 59.79-48.761c-.84-1.093-1.95-1.886-3.18-2.161z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#DFE5F5",
				d: "M1020.24 732.596c4.87 1.077 11.11-3.948 11.24-9.056l4.5-180.713c.08-3.314-2.06-6.485-4.8-7.095l-96.413-21.409c-2.73-.609-5.017 1.586-5.1 4.891l-4.658 186.798c-.083 3.347 1.828 5.843 5.017 6.552l90.204 20.032z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#A2ABDC",
				d: "M1007.59 729.783c8.64 1.92 19.72-7.011 19.94-16.076l3.82-153.185c.07-2.93-1.83-5.743-4.25-6.277l-84.964-18.863c-2.42-.535-4.44 1.402-4.515 4.331l-4.082 163.72c-.15 6.101 3.331 10.65 9.148 11.935l64.893 14.415z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#4362BA",
				d: "m949.139 560.631 73.541 16.326c.99.226 1.83-.576 1.86-1.786l.3-11.91c.04-1.211-.75-2.371-1.75-2.588l-73.542-16.334c-.993-.226-1.827.576-1.861 1.786l-.3 11.911c-.034 1.21.751 2.37 1.752 2.587z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#344080",
				d: "m979.955 564.228 42.215 9.373c.28.059.51-.208.52-.609l.21-8.397c.01-.4-.21-.767-.49-.826l-37.088-8.238c-.709-.159-1.394.175-1.836.893l-3.957 6.385c-.292.476-.05 1.302.418 1.411z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#95B0F0",
				d: "m970.565 562.825.084.017c.309.067.559-.175.567-.551l.242-9.657c.009-.367-.233-.726-.534-.793l-.083-.016c-.309-.067-.56.175-.568.55l-.242 9.657c-.008.368.234.727.534.793M967.51 562.15l.084.016c.309.067.559-.175.567-.551l.242-9.657c.009-.367-.233-.726-.534-.793l-.083-.016c-.309-.067-.56.175-.568.551l-.242 9.657c-.008.367.234.726.534.793M964.456 561.465l.083.017c.309.067.559-.176.568-.551l.242-9.657c.008-.367-.234-.726-.534-.793l-.084-.017c-.309-.067-.559.175-.567.551l-.243 9.657c-.008.367.234.726.535.793M961.409 560.788l.084.017c.308.067.559-.175.567-.551l.242-9.657c.009-.367-.233-.726-.534-.793l-.083-.017c-.309-.066-.56.176-.568.551l-.242 9.657c-.008.368.234.727.534.793M958.354 560.113l.084.017c.309.067.559-.175.567-.551l.242-9.657c.009-.367-.233-.726-.534-.793l-.083-.016c-.309-.067-.56.175-.568.551l-.242 9.657c-.008.367.234.726.534.792M955.299 559.437l.084.016c.309.067.559-.175.567-.55l.242-9.657c.009-.368-.233-.727-.534-.793l-.083-.017c-.309-.067-.56.175-.568.551l-.242 9.657c-.008.367.234.726.534.793"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#4362BA",
				d: "m948.288 594.885 73.542 16.334c.99.225 1.83-.576 1.86-1.786l.3-11.911c.04-1.21-.75-2.37-1.75-2.587L948.697 578.6c-.993-.225-1.828.576-1.861 1.787l-.301 11.91c-.033 1.211.752 2.371 1.753 2.588"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#344080",
				d: "m979.104 598.491 42.216 9.373c.28.059.51-.209.52-.609l.21-8.397c.01-.392-.21-.768-.49-.826l-37.089-8.238c-.71-.159-1.394.175-1.837.893l-3.956 6.385c-.292.476-.05 1.302.417 1.411z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#95B0F0",
				d: "m969.706 597.08.083.017c.309.067.559-.175.568-.551l.242-9.657c.008-.367-.234-.726-.534-.793l-.084-.017c-.309-.066-.559.176-.567.551l-.243 9.657c-.008.368.234.727.535.793M966.659 596.404l.083.016c.309.067.56-.175.568-.551l.242-9.657c.008-.367-.234-.726-.534-.793l-.084-.016c-.309-.067-.559.175-.567.551l-.242 9.657c-.009.367.233.726.534.793M963.604 595.728l.084.016c.309.067.559-.175.567-.55l.242-9.657c.009-.368-.233-.727-.534-.793l-.083-.017c-.309-.067-.56.175-.568.551l-.242 9.657c-.008.367.234.726.534.793M960.549 595.053l.084.017c.309.066.559-.176.567-.551l.242-9.657c.009-.368-.233-.726-.534-.793l-.083-.017c-.309-.067-.56.175-.568.551l-.242 9.657c-.008.367.234.726.534.793M957.503 594.367l.083.017c.309.067.56-.175.568-.551l.242-9.657c.008-.367-.234-.726-.534-.793l-.084-.016c-.309-.067-.559.175-.567.55l-.242 9.657c-.009.368.233.727.534.793M954.448 593.691l.083.016c.309.067.559-.175.568-.551l.242-9.657c.008-.367-.234-.726-.534-.793l-.084-.016c-.309-.067-.559.175-.567.551l-.242 9.657c-.009.367.233.726.534.793"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#4362BA",
				d: "m947.428 629.148 73.542 16.326c.99.225 1.83-.576 1.86-1.786l.3-11.911c.04-1.21-.75-2.37-1.75-2.587l-73.543-16.335c-.993-.225-1.828.576-1.861 1.787l-.301 11.91c-.033 1.21.752 2.371 1.753 2.588z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#344080",
				d: "m978.252 632.746 42.218 9.373c.28.058.51-.209.52-.609l.21-8.397c0-.401-.21-.768-.49-.826l-37.091-8.238c-.709-.159-1.394.175-1.836.893l-3.956 6.385c-.292.476-.05 1.302.417 1.41z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#95B0F0",
				d: "m968.854 631.335.084.017c.309.067.559-.175.567-.551l.242-9.657c.009-.367-.233-.726-.534-.793l-.083-.017c-.309-.066-.559.176-.568.551l-.242 9.657c-.008.367.234.726.534.793M965.799 630.658l.084.017c.309.067.559-.175.567-.551l.242-9.657c.009-.367-.233-.726-.534-.793l-.083-.016c-.309-.067-.559.175-.568.55l-.242 9.657c-.008.368.234.727.534.793M962.753 629.984l.083.016c.309.067.56-.175.568-.551l.242-9.657c.008-.367-.234-.726-.534-.793l-.084-.016c-.309-.067-.559.175-.567.551l-.242 9.657c-.009.367.233.726.534.793M959.698 629.306l.083.017c.309.066.56-.176.568-.551l.242-9.657c.008-.368-.234-.727-.534-.793l-.084-.017c-.309-.067-.559.175-.567.551l-.242 9.657c-.009.367.233.726.534.793M956.643 628.63l.083.017c.309.067.56-.176.568-.551l.242-9.657c.008-.367-.234-.726-.534-.793l-.084-.017c-.309-.067-.559.175-.567.551l-.242 9.657c-.009.367.233.726.534.793M953.596 627.955l.084.017c.309.067.559-.175.567-.551l.243-9.657c.008-.367-.234-.726-.535-.793l-.083-.017c-.309-.066-.559.176-.568.551l-.242 9.657c-.008.368.234.726.534.793"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#4362BA",
				d: "m946.577 663.403 73.543 16.335c.99.225 1.83-.576 1.86-1.787l.3-11.91c.03-1.21-.75-2.371-1.75-2.588l-73.544-16.334c-.993-.225-1.828.576-1.862 1.786l-.3 11.911c-.033 1.21.751 2.37 1.753 2.587"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#344080",
				d: "m977.401 667.001 42.219 9.373c.27.058.51-.209.52-.609l.2-8.397c.01-.392-.2-.768-.48-.826l-37.092-8.239c-.71-.158-1.394.176-1.836.894l-3.957 6.385c-.292.475-.05 1.302.418 1.41z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#95B0F0",
				d: "m968.003 665.598.083.017c.309.066.56-.176.568-.551l.242-9.657c.008-.368-.234-.727-.534-.793l-.084-.017c-.308-.067-.559.175-.567.551l-.242 9.657c-.009.367.233.726.534.793M964.948 664.922l.083.017c.309.067.56-.176.568-.551l.242-9.657c.008-.367-.234-.726-.534-.793l-.084-.017c-.308-.067-.559.175-.567.551l-.242 9.657c-.009.367.233.726.534.793M961.893 664.237l.083.017c.309.067.56-.175.568-.551l.242-9.657c.008-.367-.234-.726-.534-.793l-.084-.016c-.308-.067-.559.175-.567.551l-.242 9.657c-.009.367.234.726.534.792M958.847 663.561l.083.016c.309.067.559-.175.568-.55l.242-9.657c.008-.368-.234-.727-.535-.793l-.083-.017c-.309-.067-.559.175-.568.551l-.242 9.657c-.008.367.234.726.535.793M955.792 662.886l.083.017c.309.066.559-.176.568-.551l.242-9.657c.008-.368-.234-.726-.535-.793l-.083-.017c-.309-.067-.559.175-.568.551l-.242 9.657c-.008.367.234.726.535.793M952.745 662.209l.084.017c.308.067.559-.175.567-.551l.242-9.657c.009-.367-.234-.726-.534-.793l-.083-.017c-.309-.066-.56.176-.568.551l-.242 9.657c-.008.367.234.726.534.793"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#4362BA",
				d: "m945.726 697.658 73.544 16.326c.99.225 1.83-.576 1.86-1.786l.3-11.911c.03-1.21-.75-2.371-1.75-2.588l-73.545-16.334c-.993-.225-1.828.576-1.861 1.786l-.301 11.911c-.033 1.21.751 2.37 1.753 2.587z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#344080",
				d: "m976.541 701.263 42.219 9.374c.27.058.51-.209.52-.61l.2-8.396c.01-.401-.2-.768-.48-.827l-37.092-8.238c-.709-.158-1.394.175-1.836.893l-3.956 6.385c-.292.476-.05 1.302.417 1.411z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#95B0F0",
				d: "m967.143 699.852.083.016c.309.067.56-.175.568-.55l.242-9.657c.008-.368-.234-.727-.534-.793l-.083-.017c-.309-.067-.56.175-.568.551l-.242 9.657c-.008.367.234.726.534.793M964.097 699.177l.083.017c.309.066.559-.176.568-.551l.242-9.657c.008-.368-.234-.726-.535-.793l-.083-.017c-.309-.067-.559.175-.568.551l-.242 9.657c-.008.367.234.726.535.793M961.042 698.5l.083.017c.309.067.559-.175.568-.551l.242-9.657c.008-.367-.234-.726-.534-.793l-.084-.017c-.309-.066-.559.176-.568.551l-.242 9.657c-.008.368.234.726.535.793M957.995 697.824l.084.017c.308.067.559-.175.567-.551l.242-9.657c.009-.367-.234-.726-.534-.793l-.083-.016c-.309-.067-.56.175-.568.55l-.242 9.658c-.008.367.234.726.534.792M954.941 697.14l.083.017c.309.066.559-.176.568-.551l.242-9.657c.008-.368-.234-.727-.535-.793l-.083-.017c-.309-.067-.559.175-.568.551l-.242 9.657c-.008.367.234.726.535.793M951.886 696.464l.083.017c.309.067.559-.175.568-.551l.242-9.657c.008-.367-.234-.726-.534-.793l-.084-.017c-.309-.067-.559.176-.568.551l-.242 9.657c-.008.367.234.726.535.793"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#344080",
				d: "m943.046 531.501 84.664 18.796c1.47.326 2.7-.859 2.75-2.646l.07-2.612c.04-1.786-1.12-3.506-2.59-3.831l-84.66-18.797c-1.477-.325-2.704.86-2.754 2.646l-.067 2.613c-.042 1.786 1.118 3.505 2.587 3.831"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#EBF0FF",
				d: "M974.079 557.609c-.025 1.11.81 2.195 1.87 2.429s1.945-.468 1.97-1.578-.81-2.195-1.87-2.429-1.945.468-1.97 1.578"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FF614F",
				d: "M947.203 565.589c-.025 1.11.809 2.195 1.869 2.429s1.945-.467 1.97-1.577c.025-1.111-.809-2.196-1.869-2.429-1.06-.234-1.945.467-1.97 1.577"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#4D69BA",
				d: "M947.003 573.576c-.025 1.11.809 2.195 1.869 2.428s1.945-.467 1.97-1.577-.809-2.195-1.869-2.429-1.945.467-1.97 1.578"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M1019.71 581.698c-.02 1.11.81 2.195 1.87 2.428s1.94-.467 1.97-1.577c.02-1.11-.81-2.195-1.87-2.429s-1.94.467-1.97 1.578M1019.51 589.676c-.03 1.11.81 2.195 1.87 2.429s1.94-.467 1.97-1.578c.02-1.11-.81-2.195-1.87-2.428s-1.94.467-1.97 1.577"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#EBF0FF",
				d: "M973.228 591.48c-.025 1.11.809 2.195 1.869 2.429s1.945-.468 1.97-1.578-.809-2.195-1.869-2.429-1.945.468-1.97 1.578"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FF614F",
				d: "M946.36 599.459c-.025 1.11.81 2.195 1.87 2.429s1.944-.467 1.97-1.577c.025-1.11-.81-2.195-1.87-2.429s-1.945.467-1.97 1.577"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#4D69BA",
				d: "M946.159 607.447c-.025 1.11.81 2.195 1.87 2.428s1.945-.467 1.97-1.577-.81-2.195-1.87-2.429-1.944.468-1.97 1.578"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M1018.87 615.56c-.03 1.11.81 2.195 1.87 2.429s1.94-.468 1.97-1.578c.02-1.11-.81-2.195-1.87-2.429s-1.95.468-1.97 1.578M1018.67 623.547c-.03 1.11.81 2.195 1.87 2.429s1.94-.467 1.97-1.577c.02-1.11-.81-2.196-1.87-2.429-1.06-.234-1.95.467-1.97 1.577"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#EBF0FF",
				d: "M972.385 625.35c-.025 1.11.809 2.195 1.869 2.429s1.945-.468 1.97-1.578-.81-2.195-1.87-2.429-1.944.468-1.969 1.578"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FF614F",
				d: "M945.509 633.33c-.025 1.111.809 2.196 1.869 2.429 1.06.234 1.945-.467 1.97-1.577s-.81-2.195-1.87-2.429-1.944.467-1.969 1.577"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#4D69BA",
				d: "M945.317 641.317c-.025 1.11.809 2.195 1.869 2.429s1.945-.468 1.97-1.578-.809-2.195-1.869-2.429-1.945.468-1.97 1.578"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M1018.02 649.431c-.02 1.11.81 2.195 1.87 2.429s1.95-.468 1.97-1.578c.03-1.11-.81-2.195-1.87-2.429s-1.94.468-1.97 1.578M1017.82 657.417c-.02 1.11.81 2.195 1.87 2.429s1.95-.467 1.97-1.577c.03-1.11-.81-2.195-1.87-2.429s-1.94.467-1.97 1.577"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#EBF0FF",
				d: "M971.542 659.221c-.025 1.11.809 2.195 1.869 2.429s1.945-.468 1.97-1.578-.809-2.195-1.869-2.428-1.945.467-1.97 1.577"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FF614F",
				d: "M944.665 667.201c-.025 1.11.81 2.195 1.87 2.428s1.945-.467 1.97-1.577-.81-2.195-1.87-2.429-1.944.467-1.97 1.578"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#4D69BA",
				d: "M944.465 675.188c-.025 1.11.81 2.195 1.87 2.429s1.945-.468 1.97-1.578-.81-2.195-1.87-2.429-1.945.468-1.97 1.578"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M1017.18 683.3c-.02 1.11.81 2.195 1.87 2.429s1.95-.467 1.97-1.578c.03-1.11-.81-2.195-1.87-2.428s-1.94.467-1.97 1.577M1016.98 691.288c-.02 1.111.81 2.196 1.87 2.429 1.06.234 1.95-.467 1.97-1.577.03-1.11-.81-2.195-1.87-2.429s-1.94.467-1.97 1.577"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#EBF0FF",
				d: "M970.699 693.091c-.025 1.11.81 2.195 1.87 2.429s1.944-.467 1.969-1.577c.025-1.111-.809-2.196-1.869-2.429-1.06-.234-1.945.467-1.97 1.577"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FF614F",
				d: "M943.823 701.071c-.025 1.11.809 2.195 1.869 2.429s1.945-.468 1.97-1.578-.81-2.195-1.87-2.429-1.944.468-1.969 1.578"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#4D69BA",
				d: "M943.622 709.059c-.025 1.11.81 2.195 1.87 2.429s1.945-.468 1.97-1.578-.81-2.195-1.87-2.429-1.945.468-1.97 1.578"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#fff",
				strokeMiterlimit: 10,
				strokeWidth: .61,
				d: "m1031.78 723.807 4.5-180.712c.08-3.314-2.06-6.486-4.8-7.095l-96.413-21.409"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#272B47",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2.02,
				d: "m923.791 429.714 7.136-55.539s.359-6.702-5.767-8.021l-48.661-10.466M702.472 496.895l158.394 33.754 5.317 1.152s10.658 1.369 12.695-9.156l9.74-85.111"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#848BB2",
				d: "M904.62 752.088c30.522 0 55.265-3.519 55.265-7.86s-24.743-7.86-55.265-7.86c-30.521 0-55.264 3.519-55.264 7.86s24.743 7.86 55.264 7.86",
				opacity: .2
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#full-page-error_svg__g)",
				d: "m899.505 675.425-1.657-.777c-3.884-1.818-14.732 13.198-24.216 33.536s-14.029 38.287-10.144 40.105l1.656.777.484-1.041c4.911-2.463 13.97-15.925 22.062-33.272 8.458-18.139 12.987-34.371 11.096-38.961l.704-.367z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#full-page-error_svg__h)",
				d: "M865.158 749.067c-3.884-1.818.66-19.766 10.144-40.105s20.332-35.354 24.217-33.535c3.885 1.818-.66 19.766-10.144 40.105s-20.332 35.354-24.217 33.535"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#full-page-error_svg__i)",
				d: "M870.905 737.334c1.466-6.98 4.691-16.276 9.265-26.101 4.06-8.71 8.487-16.321 12.518-21.834a88 88 0 0 1 1.525-2.024c.366-.469 1.085-.498 1.51-.073l8.062 8.079.367.367.586.601 9.279 9.312.323.322 9.674 9.708 1.701 1.715 8.868 8.886.66.66 12.739 12.787c1.803 1.804.117 5.411-2.419 5.191l-16.271-1.408-1.716-.146-.938-.074-12.504-1.085-2.404-.205-13.647-1.188-.455-.029-13.09-1.144-.836-.073-.513-.044-11.375-.983a1.01 1.01 0 0 1-.909-1.202z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#F9FBFC",
				d: "M884.538 739.638c1.847-6.35 4.808-14.136 8.634-22.333s7.872-15.47 11.566-20.969l9.279 9.311c-2.99 4.869-6.113 10.719-9.103 17.127-2.991 6.408-5.453 12.567-7.271 17.993l-13.09-1.144zM914.149 742.204c1.51-3.988 3.313-8.241 5.35-12.61a185 185 0 0 1 6.23-12.2l8.869 8.886.66.66a199 199 0 0 0-4.017 8.123 213 213 0 0 0-3.65 8.3l-.938-.073z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#E9E5D9",
				d: "M870.905 737.336c1.466-6.98 4.691-16.277 9.264-26.101 4.061-8.711 8.488-16.321 12.519-21.835-2.492 5.749-6.157 16.541-4.442 27.348 2.126 13.476 32.206 23.961 41.06 26.761l-1.715-.146-.938-.074-12.504-1.085-2.404-.205-13.648-1.188-.454-.029-13.091-1.144-.835-.073-.513-.044-11.376-.983a1.01 1.01 0 0 1-.909-1.202z",
				style: { mixBlendMode: "multiply" }
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "full-page-error_svg__b",
			x1: 989.619,
			x2: 355.059,
			y1: 146.95,
			y2: 924.524,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#EFEFF3" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#fff"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "full-page-error_svg__c",
			x1: 993,
			x2: 993,
			y1: 464.681,
			y2: 902.068,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .06,
					stopColor: "#C8E6FF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .28,
					stopColor: "#C8E6FF"
				}),
				/* @__PURE__ */ _jsx("stop", { offset: 1 })
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "full-page-error_svg__d",
			x1: 404.081,
			x2: 655.403,
			y1: 539.155,
			y2: 539.155,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E37D03" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#BE6700"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "full-page-error_svg__e",
			x1: 404.082,
			x2: 655.404,
			y1: 533.481,
			y2: 533.481,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E3A504" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#E37D03"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "full-page-error_svg__f",
			x1: 529.718,
			x2: 529.718,
			y1: 357.798,
			y2: 497.224,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E3A504" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#E37D03"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "full-page-error_svg__g",
			x1: 862.095,
			x2: 899.505,
			y1: 711.791,
			y2: 711.791,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#BE6700" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#E37D03"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "full-page-error_svg__h",
			x1: 899.336,
			x2: 864.965,
			y1: 675.604,
			y2: 749.222,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E3A504" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#E37D03"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "full-page-error_svg__i",
			x1: 933.577,
			x2: 892.765,
			y1: 736.429,
			y2: 717.387,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E3A504" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#E37D03"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "full-page-error_svg__a",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M0 0h1379v995H0z"
			})
		})
	] })]
});
export default SvgFullPageError;
